module.exports = "img/montenativo.c8da2a.jpg";